<template>
    <div class="wl-tree-menu">
        <ul class="wl-tree-item wl-tree-root"
            v-for="(item,index) in commentList"
            :key="index">
            <tree-item ref="tree"
                       :data="item"
                       :index="index"
                       :onAdd="onAdd">
            </tree-item>
        </ul>
    </div>
</template>

<script>
    import TreeItem from './tree-item';

    export default {
        data() {
            return {
                commentList: []
            }
        },
        methods: {
            hideComment(pid) {
                const refList = this.$refs.tree;
                for (let i = 0; i < refList.length; i++) {
                    if (refList[i].data.id === pid) {
                        refList[i].toggleCommentVisible();
                    }
                }
            }
        },
        watch: {
            data: {
                handler: function (val, oldval) {
                    if (val) {
                        this.commentList = val
                    }
                }
            }
        },
        props: {
            data: {
                type: [Object, Array],
                required: true
            },
            onAdd: {
                type: Function,
                required: true
            }
        },
        components: {
            TreeItem
        }
    };
</script>
<style scoped>
    .wl-tree-item {
        background: #fff;
        margin: 8px 0;
        padding: 12px;
    }

    ul {
        list-style: none;
        user-select: none;
    }
</style>
